import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../core/service/v2/abstractRepositoryV2';
import {SubscriptionModel} from '../../../api/entity/subscription.model';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionRepository extends AbstractRepositoryV2<SubscriptionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Subscription', serviceElementsFactory, injector);
    }
}
